<template>
  <div
    :class="'images-viewer shadow__ ' +
      (compact ? 'images-compact' : '') +
      (wide ? 'wide-view' : '')
    "
    @mouseleave="startAuto"
    @mouseenter="stopAuto"
  >
    <!-- DESKTOP -->
    <template v-if="!compact">
      <ObjectImagesFull
        v-if="showingFullImage"
        :images="images"
        :compact="compact"
        :rooms="rooms"
        :img-folder="imgFolder"
      />
      <ObjectImagesPreview
        :images="images"
        :compact="compact"
        :rooms="rooms"
        :wide="wide"
        :img-folder="imgFolder"
      />
    </template>

    <!-- MOBILE -->

    <template v-else>
      <!--
      moved to top because of scroll issue
      object-images-full-mobile
        v-if="showingFullImage"
        :images="images"
        :compact="compact"
      / -->
      <object-images-preview-mobile
        :images="images"
        :compact="compact"
        :img-folder="imgFolder"
      />
    </template>
  </div>
</template>

<script>
import sharedMethods from '../../methods/sharedMethods'
import methods from '../../methods/methods'
import ObjectImagesFull from './ObjectImagesFull'
import ObjectImagesPreview from './ObjectImagesPreview'
import ObjectImagesPreviewMobile from './ObjectImagesPreviewMobile'
import vuescroll from 'vue-scroll'
import Vue from 'vue'
import { createHelpers } from 'vuex-map-fields'
import state from '../../store/state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})
Vue.use(vuescroll)

export default {
  name: 'ObjectImages',

  components: {
    ObjectImagesFull,
    ObjectImagesPreview,
    ObjectImagesPreviewMobile,
  },

  props: {
    images: {
      type: Array,
      default: () => {
        return []
      },
    },
    rooms: {
      type: Array,
      default: () => {
        return []
      },
    },
    compact: {
      type: Boolean,
      default: false,
    },
    wide: {
      type: Boolean,
      default: false,
    },
    imgFolder: {
      type: String,
      default: null,
    },
  },

  created () {
    window.addEventListener('resize', this.resizeHandler)
    this.initListData()
    this.autoNextImg()
  },

  destroyed () {
    clearTimeout(this.imageAutoSwitchTimer)
    window.removeEventListener('resize', this.resizeHandler)
  },

  watch: {
    openedObjectId (value) {
      this.initListData()
    },
    pageId (value) {
      this.initListData()
    },
  },

  computed: {
    ...mapFields(Object.keys(state)),

    openedObjectId () {
      return this.selectedObject && this.selectedObject._id ? this.selectedObject._id : false
    },

    objectId () {
      return this.$route && this.$route.params &&  this.$route.params.object_id || null
    },
  },

  methods: {
    ...methods,
    ...sharedMethods,

    initListData () {
      if (this.images.length > 0) {
        this.whichImageShowing = 1
        this.image1Transparent = false
        this.image2Transparent = true
        this.selectedImageIndex = 0
        this.imagePreviewThumbnailLeftOffset = 0
        this.imageUrl1 = this.images[0].image
        this.previewImage1 = this.images[0]
        this.fullImage1 = this.images[0]
        if (this.images[1]) {
          this.imageUrl2 = this.images[1].image
          this.fullImage2 = this.images[1]
          this.previewImage2 = this.images[1]
          this.previewSideImage2 = this.images[1]
          this.previewSideImage3 = this.images[2]
        }
      }
    },

    resizeHandler () {
      this.windowHeight = window.innerHeight
      this.windowWidth = window.innerWidth

      // Change contentAreaWidth
      this.setContentAreaWidth()
    },
  },
}
</script>

<style lang="scss">
.hot-img-caption {
  position: absolute;
  font-weight: bold;
  color: black;
  padding: 5px 10px;
  text-align: left;
  bottom: 15px;
  /* left: 2px; */
  left: 0;
  /* background-color: #ffcb01; */
  width: 272px;
  height: 74px;
  z-index: 2;
  font-size: 12px;
  background: url(../../../public/img/promo_text_bg.png) no-repeat;
  cursor: pointer;
}
.desktop-view .images-viewer {
  border-radius: 10px;
  overflow: hidden;
  -webkit-transform: translate3d(0, 0, 0); /* For Safari */
  -webkit-overflow: hidden;

}
.images-viewer {
  /* border: 1px solid #eaeaea; */
  padding: 0;
  /* max-width: 846px; */
  clear:both;
  position: relative;
}
.images-compact {
  border: none;
  /* border-top: 1px solid white; */
}
.desktop-view .viewer-image {
  border-radius: 8px 0 0 8px;
  overflow: hidden;
  -webkit-transform: translate3d(0, 0, 0); /* For Safari */
  -webkit-overflow: hidden;
}
.desktop-view .viewer-image-homepage {
  border-radius: 8px 8px 0 0;
  overflow: hidden;
  -webkit-transform: translate3d(0, 0, 0); /* For Safari */
  -webkit-overflow: hidden;
}
.viewer-image {
  position: relative;
  height: 372px;
  width: 100%;
  /* width: calc(100% - 4px); */
  /* margin:2px; */
  cursor: pointer;
}
/*.viewer-image-middle-container {
  position: absolute;
  top: -14px;
  width: 900px;
  left: 50%;
  margin-left: -450px;
}*/

.viewer-compact-container {
  margin: 0;
  width: 100%;
  /* height: 232px; */
}
.viewer-image-middle-container {
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin-left: 0;
  justify-content: center;
  align-items: center;
  display: flex;
}
.viewer-image-middle-container .v-image, .full-container-img-outer .v-image {
  /* height: 420px; */
  height: 100%;
  -webkit-transition: opacity .5s ease-in-out;
  -moz-transition: opacity .5s ease-in-out;
  -o-transition: opacity .5s ease-in-out;
  transition: opacity .5s ease-in-out;
  opacity: 1;
  position:absolute;
  left:50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  -webkit-backface-visibility: hidden;
}
.viewer-compact-container div img {
  width: 100%;
}
.full-container {
  position: relative;
  padding: 0;
  margin: 0;
  outline: none;
  height: 100%;
  overflow: auto;
}
.full-container-img-outer img {
  /* border: 10px solid #fff; */
  border-radius: 10px;
  margin: auto;
  position: absolute;
  height: auto;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
}
@media only screen and (max-width: 959px) {
  .full-container-img-outer img  {
    /* border: 5px solid #fff; */
    width: 100%;
    margin: 0;
  }
}
.full-container-img-outer {
  margin: auto;
	display: flex;
  width: 100%;
}

.img-transparent, .img-transparent a {
  opacity: 0.0 !important;
  z-index: 2 !important;
}
.img-transparent a {
  opacity: 1;
}
.not-selected {
  opacity: 0.4;
}
.viewer-thumbnail-image:hover {
  /*opacity: 1 !important;*/
}
.viewer-thumbnails {
  width: 10000px;
  position: absolute;
  top: 0;
  left: 0;
}
.viewer-thumbnails-outer {
  position: relative;
  width: calc(100% - 8px);
  height: 64px;
  margin: 4px;
  overflow: hidden;
}
.viewer-thumbnail {
  position: relative;
  height: 100%;
  text-align: center;
  vertical-align: middle;
  overflow: hidden;
  float: left;
  list-style: none;
  width: 83px;
  height: 63px;
  margin: 0;
  padding: 0;
  overflow: hidden;
  float: left;
  list-style-type: none;
  background: #fafafa;
  border: 1px solid #e5e5e5;
  cursor: pointer;
  margin-right: 5px;
  transition: left 0.5s ease-out;
  -moz-transition: left 0.5s ease-out;
  -webkit-transition: left 0.5s ease-out;
  -o-transition: left 0.5s ease-out;
}
.viewer-thumbnail-image:hover {
  opacity:1;
  transition: opacity .5s ease-out;
  -moz-transition: opacity .5s ease-out;
  -webkit-transition: opacity .5s ease-out;
  -o-transition: opacity .5s ease-out;
}
.viewer-thumbnail-inner {
  border: 3px solid white;
  overflow: hidden;
}
.viewer-thumbnail-image {
  -webkit-backface-visibility: hidden;
  height: 55px;
}
.next-btn i, .prev-btn i {
  color: #666;
  font-size: 24px;
}
.prev-btn {
  padding: 11px 8px 8px 14px;
}
.next-btn {
  padding: 11px 8px 8px 17px;
}
.next-btn, .prev-btn {
  opacity: 0.8;
  border-radius: 100px;
  background: white;
  top: 190px;
  height: 45px;
  width: 45px;
  cursor: pointer;
  position: absolute;
  display: block;
  z-index: 3;
  text-decoration: none;
}
.wide-view {
  .next-btn, .prev-btn {
    top: 252px;
  }
}
.list-object .viewer-image .next-btn, .list-object .viewer-image .prev-btn {
  top: 179px;
}
.next-btn {
  right: 15px;
}
.prev-btn {
  left: 15px;
}
.viewer-nav a {
  opacity: 0.8;
  transition: 1.0s ease-out;
  -moz-transition: 1.0s ease-out;
  -webkit-transition: 1.0s ease-out;
  -o-transition: 1.0s ease-out;
}
.pika-counter {
  position: absolute;
  bottom: 15px;
  right: 15px;
  color: white;
  background: rgba(0,0,0,0.5);
  font-size: 11px;
  padding: 3px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  z-index: 1000;
}
.expand-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 14px;
  z-index: 200;
  opacity: 0.85;
  /* color: white;
  background: rgba(0,0,0,0.3);
  padding: 5px 4px 2px 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  cursor: pointer;*/
}
.compact-bullets {
  opacity: 0.9;
  width: 100%;
  text-align: center;
  position: absolute;
  bottom: 0; left: 0;
  z-index: 1;
  height: 20px;
  line-height: 20px;
  color: white;
  font-size: 8px;
}
.compact-bullets i {
  padding: 0 3px;
}
</style>
